import { render, staticRenderFns } from "./EditInjection.vue?vue&type=template&id=295f765e&scoped=true"
import script from "./EditInjection.vue?vue&type=script&lang=js"
export * from "./EditInjection.vue?vue&type=script&lang=js"
import style0 from "./EditInjection.vue?vue&type=style&index=0&id=295f765e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295f765e",
  null
  
)

export default component.exports